import { Box } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { doGetProformaSummaryAsync, selectInvoice, selectSummary } from './ProformaEditorSlice';

import * as Styled from './ShortProformaSummary.styles';

export default function ShortInvoiceSummaryPanel(props) {
  const dispatch = useDispatch();

  const invoice = useSelector(selectInvoice);
  const summary = useSelector(selectSummary);

  React.useEffect(() => {
    const payload = {
      items: invoice.items,
      currency: invoice.currency,
    };

    dispatch(doGetProformaSummaryAsync(payload));
  }, [invoice.items]);

  return (
    <Box style={{ marginLeft: 'auto' }}>
      <Stack direction="row" flexGrow={1} sx={{ mt: 3 }}>
        <Stack direction="column" flex={1}>
          <Styled.Label width={150}>Suma netto:</Styled.Label>
          <Styled.Label width={150}>Suma VAT:</Styled.Label>
          <Styled.Title width={150}>Suma brutto:</Styled.Title>
        </Stack>
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="stretch"
          sx={{ ml: 1, mr: 2, flex: 1, whiteSpace: 'nowrap' }}
        >
          <Styled.Label>{summary.netTotal}</Styled.Label>
          <Styled.Label>{summary.taxTotal}</Styled.Label>
          <Styled.Title>{summary.grossTotal}</Styled.Title>
        </Stack>
      </Stack>
    </Box>
  );
}
